module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/images/bg-pattern-active.6d5f1114.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/images/bg-pattern-active.png
// module id = 3080
// module chunks = 11